const ENV_FLAG_KEY = 'REACT_APP_IS_BITMOVIN_KEY';

function readFlagValue(value) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['false', '0', 'no', 'off', ''].includes(normalized)) return false;
    if (['true', '1', 'yes', 'on'].includes(normalized)) return true;
  }
  return undefined;
}

/**
 * Controlled only by REACT_APP_IS_BITMOVIN_KEY.
 * true  → Bitmovin player
 * false → native React <video> player
 */
export function isBitmovinPlayerEnabled() {
  const configured = readFlagValue(process.env[ENV_FLAG_KEY]);
  return configured === true;
}
